// project-imports
import { getRequest, postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - INTERNATIONAL CONFIRMATION ||============================== //

export async function handleInternationalConfirmation(action: APIAction) {
  switch (action.method) {
    // Lista completa (admin) o por usuario si pasas cognitoId
    case 'read': {
      const cognitoId = action.data?.cognitoId;
      const qs = cognitoId ? `?cognito-id=${encodeURIComponent(cognitoId)}` : '';
      return getRequest(`/international-confirmation${qs}`);
    }

    // Última confirmación por usuario (para TTL < 1h)
    case 'read-latest': {
      const cognitoId = action.data?.cognitoId;
      if (!cognitoId) {
        console.info('[ApiManager > handleInternationalConfirmation] - Missing cognitoId for read-latest');
        return null;
      }
      return getRequest(`/international-confirmation/latest?cognito-id=${encodeURIComponent(cognitoId)}`);
    }

    // Guardar confirmación (siempre)
    // action.data: { cognitoId: string, confirmation: boolean }
    case 'create': {
      const { cognitoId, confirmation } = action.data || {};
      if (!cognitoId || confirmation === undefined) {
        console.info('[ApiManager > handleInternationalConfirmation] - Missing cognitoId or confirmation for create');
        return null;
      }

      // El backend espera "cognitoid" (según el router que montamos)
      return postRequest('/international-confirmation', {
        cognitoid: cognitoId,
        confirmation
      });
    }

    default:
      console.info('[ApiManager > handleApiAction > handleInternationalConfirmation] - Unknown method');
      break;
  }
}
